<template>
  <div id="user-page" class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-2">
        <h5>フォルダ一覧</h5>
      </div>
      <div class="col-6">
        <button id="createUserBtn" type="button" class="btn-sm btn-outline-info btn_right" v-on:click="create" v-if="isAdmin">共有フォルダを作成する</button>      
        <button type="button" class="btn-sm btn-outline-success btn_right" v-on:click="refreshId" v-if="isAdmin">最新のユーザーから個人フォルダを作成する</button>      
      </div>
    </div>
    <div id="seach_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8 form-group">
        <form class="input-group" @submit.prevent="search(true)">
          <input type="text" class="form-control" v-model="searchKey" placeholder="名称">        
          <div class="input-group-append">
              <button class="btn btn-secondary" type="submit">
                <img class="search-solid" src="/search-solid.svg">
              </button>
          </div>
        </form>
      </div>
    </div>
    <div id="main" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <table class="table table-dark table-sm table-hover">
          <thead>
            <tr>
              <th scope="col" style="width:70px">#</th>
              <th scope="col">名称</th>
              <th scope="col" style="width:200px">更新日時</th>
              <th scope="col" style="width:150px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(folder, index) in folders" v-bind:key="folder.folderId">
              <th scope="row">{{ currentIndex * limit + index + 1 }}</th>
              <td>{{ folder.folderName }}</td>
              <td>{{ folder.lastModified }}</td>
              <td>
                <button type="button" class="btn-sm btn-light" v-on:click="open(folder.folderId)">開く</button>
                <button type="button" class="btn-sm btn-light" v-if="!folder.isPrivate && isAdmin" v-on:click="modify(folder.folderId)">編集する</button>
              </td>
            </tr>
          </tbody>
        </table>
        <nav aria-label="pager">
          <ul class="pagination justify-content-center">
            <li v-if="isPrev" v-on:click="goPrev">
              <a class="btn page-link rounded-pill">&larr; 前</a>
            </li>
            <li v-if="isPrev||isNext" class="mx-2">
              <a class="btn page-link rounded-pill">現在</a>
            </li>
            <li v-if="isNext" v-on:click="goNext">
              <a class="btn page-link rounded-pill">次 &rarr;</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-2">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import authority from '../../authority'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Index',
  mixins: [sessions,path,headers],
  props: ['realms'],
  src: {
    authority
  },
  data: function(){
    return {
      folders: [],
      message: '',
      gridCount: 0,
      currentIndex: 0,
      limit: 20,
      searchKey: ''
    }
  },
  mounted() {
    if(this.$store.getters.folderSearch.searchKey !== ''){
      this.searchKey = this.$store.getters.folderSearch.searchKey
    }
    if(this.$store.getters.folderSearch.currentIndex !== 0){
      this.currentIndex = this.$store.getters.folderSearch.currentIndex
    }
    if(this.$store.getters.hospital.id !== 0){
      this.search(false)
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.search(true)
        }
      }
    )
  },
  computed: {
    isNext: function () {
      return this.gridCount === this.limit
    },
    isPrev: function () {
      return this.currentIndex !== 0
    },
    isMessage: function () {
      return this.message.length > 0
    },
    isAdmin: function () {
      var overAdmin = authority.isAdmin.concat(authority.isSuper)
      return overAdmin.includes(Number(this.$store.state.user.privilege))
    }
  },
  methods: {
    create() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/photo/folder/create'))
    },
    modify(id) {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/photo/folder/modify/'+id))
    },
    open(id) {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/photo/folder/'+id))
    },
    refreshId() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          axios.get("/api/folder/management/refresh/" + hospitalId, {
            headers: this.headers(accessToken)
          }).then(res => {
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('作成処理が実施されました。')
              this.search(true)
            }
          }).catch(err => {
            this.message = err.message
          })
        } else {
          this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    search(isInit) {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          if(isInit){
            this.currentIndex = 0
          }
          var offset = this.currentIndex * this.limit
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          var privilege = this.$store.getters.user.privilege
          var url = this.isAdmin ? "/api/folder/management/admin/list/" : "/api/folder/management/list/"
          if(this.searchKey.length > 0){
          axios
            .post(url + "search" + "/" + offset, {
              hospitalId : hospitalId,
              searchKey : this.searchKey,
              privilege : privilege
            },{
                headers: this.headers(accessToken)
            })
            .then(response => {
              this.folders = response.data.data.folders;
              this.gridCount = this.folders.length
              this.$store.commit('folderSearch',{
                searchKey: this.searchKey,
                currentIndex: this.currentIndex
              })
            })
            .catch(err => {
              this.message = err.message
              this.$store.commit('folderSearch',{
                searchKey: '',
                currentIndex: 0
              })
            })
          } else{
          axios
            .post(url + offset, {
              hospitalId : hospitalId,
              privilege : privilege
            },{
                headers: this.headers(accessToken)
            })
            .then(response => {
              this.folders = response.data.data.folders;
              this.gridCount = this.folders.length
              this.$store.commit('folderSearch',{
                searchKey: this.searchKey,
                currentIndex: this.currentIndex
              })
            })
            .catch(err => {
              this.message = err.message
              this.$store.commit('folderSearch',{
                searchKey: '',
                currentIndex: 0
              })
            })
          }
        } else {
          this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    goNext(){
      this.currentIndex++
      this.search(false)
    },
    goPrev(){
      this.currentIndex--
      this.search(false)
    },
  } 
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#main {
  height: 100%;
}
#createUserBtn {
  float:right;
}
.btn-sm{
  margin-left: 5px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.search-solid{
  cursor: pointer;
  height: 18px;
  width: 18px;
}
.btn_right {
  float:right;
}
</style>
